// extracted by mini-css-extract-plugin
export default {"container":"HomeTBR_container__0Dm22","content":"HomeTBR_content__Hw4jj","emptyShelf":"HomeTBR_emptyShelf__IZrCy","loader":"HomeTBR_loader__Gk3kI"};